"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogTitle.default;
  }
});

var _DialogTitle = _interopRequireDefault(require("./DialogTitle"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/DialogTitle/index.js
// module id = 135
// module chunks = 0